import { setToken, setAuthToken } from './authorization'
import { TenantType } from '../config/enums'
import { setHttpConfig, env, appVersion } from '../config/http.config'
import { HostType } from '../config/type'
import { loadDevApiConfig } from '../config/dev'

/** 初始化API配置 */
export function initApiConfig() {
  setToken() // 每次加载清除token，避免使用浏览器缓存
  setAuthToken()
  setHttpConfig({
    hostType2: HostType.platformApi,
    env2: env,
    appVersion2: appVersion
  })
}
/** 处理移动端和pc端访问跳转 */
export function handleUrlJump() {
  const url = location.href
  const host = location.host.replace('www.', '')
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(navigator.userAgent) &&
    window.screen.width < window.screen.height
  ) {
    //平板，不跳转
    //手机
    judgeIsJumpUrl('pc')
  } else {
    //PC
    console.log('当前为PC端------', host, url)
    judgeIsJumpUrl('m')
  }
}
/** 处理移动端和pc端访问跳转 */
function judgeIsJumpUrl(replaceType) {
  const jumpList = [
    {
      m: '/#/m/share/share/',
      pc: '/#/share/share/'
    }
  ]
  const url = location.href
  const strategy = {
    pc: () => {
      const item = jumpList.find((item) => {
        return url.toLocaleLowerCase().indexOf(item.pc) > -1
      })
      if (item) {
        const path = item.m
        location.href = url.replace(item.pc, path)
        console.log('pc跳手机', location.href)
      }
    },
    m: () => {
      const item = jumpList.find((item) => {
        return url.toLocaleLowerCase().indexOf(item.m) > -1
      })
      if (item) {
        const path = item.pc
        location.href = url.replace(item.m, path)
        console.log('手机跳pc', location.href)
      }
    }
  }
  if (strategy[replaceType]) {
    strategy[replaceType]()
  }
}

/** 文件下载验证码校验 */
export function loadExternalScript(url) {
  const script = document.createElement('script')
  script.src = url
  script.async = true
  document.head.appendChild(script)
}

export function setDownloadVerifyApiHost(val) {
  window.downloadVerifyApiHost = val
}
